export default class ConnectedServiceParam {
    constructor (dto) {
        this.name = ''
        this.label = ''
        this.value = ''
        this.isRequired = false

        if (dto) {
            this.name = dto.ParamName
            this.label = dto.ParamLabel
            this.value = dto.ParamValue
            this.isRequired = dto.Required
        }
    }

    toDto () {
        return {
            ParamName: this.name,
            ParamValue: this.value,
        }
    }
}
